var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/~/core-js/modules/_has.js
// module id = ROQC
// module chunks = 1